import keyMirror from 'keymirror';
import moment from 'moment';

export const resultDetailsActionTypes = keyMirror({
	GET_RESULT_DETAILS_REQUEST: null,
	GET_RESULT_DETAILS_SUCCESS: null,
	GET_RESULT_DETAILS_ERROR: null,

	GET_EXERCISE_TYPES_REQUEST: null,
	GET_EXERCISE_TYPES_SUCCESS: null,
	GET_EXERCISE_TYPES_ERROR: null,

	CLEAN_EXERCISE_TYPES_STATE: null,
	OPEN_RATING_MODAL: null,
});

export const getResultDetailsOrderOptions = (t) => [
	t('result_details_core.order_options.original'),
	t('result_details_core.order_options.alphabetical'),
	t('result_details_core.order_options.all_results'),
	t('result_details_core.order_options.last_results'),
	t('result_details_core.order_options.this_result'),
];

export const formatTime = (finishedAt, startedAt) => {
	const duration = moment.duration(moment(finishedAt).diff(moment(startedAt)));
	const minutes = duration.minutes();
	const seconds = duration.seconds();
	return moment.utc((minutes * 60 + seconds) * 1000).format('mm:ss');
};

export const linkTo = {
	quiz: 'quizzes',
	list: 'lists',
	topic: 'topics',
	chapter: 'chapters',
};
